<template>
  <div>
    <div class="form-group gallery-question-header">
      <h3
        :class="template.style.surveyBackground ? 'text-white' : 'text-dark'"
        class="font-weight-bold text-center gallery-question-title"
        for="nome"
      >
        {{ questionText }}
      </h3>
      <p
        v-if="questionObs"
        class="observation text-center gallery-question-description"
        :class="template.style.surveyBackground ? 'text-white' : 'text-dark'"
        :style="descriptionStyle"
      >
        {{ questionObs }}
      </p>
    </div>

    <span></span>

    <div
        class="q-buttonlist-selected"
        vs-align="center"
        vs-type="flex"
        vs-justify="space-around"
        v-show="showSelected"
    >
      <div
          v-for="(opt, index) in answerList"
          v-bind:key="index"
          class="align-middle"
      >
        <vs-icon
            icon="done"
            :color="'#038835'"
            v-on:click="removeOption(opt)"
            class="align-middle iconDeselect"
        ></vs-icon>
        <label :color="'#038835'">{{ opt }}</label>
      </div>
    </div>

    <div
        class="sur-qtext d-flex justify-content-center flex-wrap align-items-stretch"
        :class="isCircleImage ? 'gallery-grid--circle' : 'gallery-grid--square'">
      <!--
  <div v-show="show" class="pt-2">
      <vs-row v-for="(opt, index) in list" v-bind:key="opt.value">
          <vs-button :type="getBtnType(opt.text)"
                     :ref="'btn_' + index"
                     class="btnOtion btn-block mb-2"
                     v-on:click="ChooseOption(opt.text, $event)">{{ opt.text }}</vs-button>
      </vs-row>
  </div>
      -->
      <div
          class="p-2 align-self-stretch"
          :class="isCircleImage ? 'col-6 col-md-6 gallery-item--circle' : 'col-6 col-md-6 gallery-item--square'"
          v-for="(opt, index) in newList"
          v-bind:key="index">
        <div class="img-btn con-vs-card h-100" style="background-color: #fff;">
          <div class="vs-card--content d-flex flex-column justify-content-between h-100">
            <h4 class="text-center pt-3 mb-4 gallery-item-title">
              {{ opt.text }}
            </h4>
            <div
                v-if="isCircleImage"
                class="gallery-image-wrap gallery-image-wrap--circle"
                :class="{ 'gallery-image-wrap--clickable': isMobileView }"
                :style="circleWrapStyle"
                @click="openImagePreview(opt)">
              <div class="gallery-circle-static vh--outer vh--rel">
                <div class="vh--holder vh--rel vh--flex vh--jc">
                  <picture>
                    <img
                        :src="opt.url"
                        class="img-fluid gallery-image--circle"
                        :alt="opt.text">
                  </picture>
                </div>
              </div>
            </div>
            <template v-else>
              <div
                  v-if="isMobileView"
                  class="gallery-image-wrap gallery-image-wrap--square gallery-image-wrap--clickable"
                  @click="openImagePreview(opt)">
                <img
                    :src="opt.url"
                    class="img-fluid gallery-image--mobile"
                    :style="getMobileImageStyle(opt)"
                    :alt="opt.text">
              </div>
              <template v-else>
                <image-zoom
                    v-if="opt.zoom === 'true'"
                    :regular="opt.url"
                    :zoom="opt.url"
                    :zoom-amount="2.5"
                    :click-zoom="true"
                    :show-message="true"
                    :show-message-touch="false"
                    img-class="img-fluid"
                    width="100%"
                    height="300px"
                    style="object-fit: contain"
                    :alt="opt.text">
                </image-zoom>
                <img
                    v-else
                    :src="opt.url"
                    :style="{ width: '100%', aspectRatio: opt.aspectRatio, objectFit: 'cover', objectPosition: opt.objectPosition }"
                    :alt="opt.text">
              </template>
            </template>
            <p
                v-if="showVotePercent"
                class="gallery-vote-percent text-center mt-2 mb-0"
                :style="votePercentStyle">
              <span class="gallery-vote-percent__desktop">{{ formatVotePercent(getVotePercent(opt)) }}</span>
              <span class="gallery-vote-percent__mobile">{{ formatVotePercentShort(getVotePercent(opt)) }}</span>
            </p>
            <vs-row>
              <button v-if="!answerList.includes(opt.text)" type="button"
                      class="btn btn-primary w-100 font-weight-bold btn-block mt-2 mx-auto gallery-vote-btn"
                      v-on:click="ChooseOption(opt.text, $event)">
                VOTAR
              </button>
              <button v-else type="button"
                      class="btn btn-primary w-100 font-weight-bold btn-block mt-2 mx-auto c-seledted-btn gallery-vote-btn"
                      v-on:click="removeOption(opt.text, $event)">
                <vs-icon
                    icon="done"
                    :color="'#038835'"
                    v-on:click="removeOption(opt)"
                    class="align-middle iconDeselect"
                ></vs-icon>
                REMOVER VOTO
              </button>
            </vs-row>
          </div>
        </div>
      </div>
    </div>

    <div
        v-if="imagePreview.open"
        class="gallery-image-preview"
        @click="closeImagePreview">
      <button
          type="button"
          class="gallery-image-preview__close"
          aria-label="Fechar preview"
          @click.stop="closeImagePreview">
        &times;
      </button>
      <img
          :src="imagePreview.url"
          :alt="imagePreview.alt"
          class="gallery-image-preview__img"
          @click.stop>
    </div>
  </div>
</template>

<script>

const configDomain = process.env.VUE_APP_CONFIGDOMAIN;

import {mask} from "vue-the-mask";
import imageZoom from 'vue-image-zoomer';
import { Survey } from "../../services/Survey.js";

const s = new Survey();

export default {
  name: "Survey-Input-List",
  components: {
    imageZoom
  },
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    show: false,
    showInput: true,
    newList: [],
    list: [],
    answerList: [],
    nMax: 1,
    nselected: 0,
    votePercents: {},
    isMobileView: false,
    imagePreview: {
      open: false,
      url: "",
      alt: ""
    }
  }),
  directives: {mask},
  props: {
    questionText: {type: String},
    questionObs: {type: String, default: ""},
    questionId: {type: Number},
    options: [],
    config: {type: String}
  },
  computed: {
    showSelected: function () {
      if (this.nselected > 0) return true;
      else return false;
    },
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      else return this.$t('type_answer_here');
    },
    template() {
      return this.$store.state.template
    },
    descriptionStyle() {
      if (this.template?.style?.secondColor) {
        return { color: this.template.style.secondColor };
      }
      if (this.template?.style?.surveyTextColor) {
        return { color: this.template.style.surveyTextColor };
      }
      return {};
    },
    imageShape() {
      if (!this.config || !this.config.includes("imageShape:")) return null;

      const opts = this.config.split(";");
      for (let i = 0; i < opts.length; i++) {
        if (opts[i].includes("imageShape:")) {
          return opts[i].split(":")[1].trim().toLowerCase();
        }
      }
      return null;
    },
    isCircleImage() {
      return this.imageShape === "circle";
    },
    circleWrapStyle() {
      if (!this.isCircleImage) return {};

      const color = this.template?.style?.btnTextColor;
      return color
        ? { borderColor: color }
        : {};
    },
    showVotePercent() {
      if (!this.config) return false;
      return this.config.includes("showVotePercent");
    },
    votePercentStyle() {
      const color = this.template?.style?.surveyTextColor;
      return color ? { color } : {};
    },
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    }
  },
  created() {
    this.showInput = true;
    this.show = false;

    if (this.config) {
      if (this.config.includes("noinput")) {
        this.showInput = false;
        this.show = true;
      }

      if (this.config.includes("n:")) {
        var opts = this.config.split(";");
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("n:")) {
            var r = opts[i].split(":");
            if (r[1] == "x") this.nMax = this.options.length;
            else this.nMax = r[1];
          }
        }
      }
    }
    // this.answerList = new Array(this.nMax);

    //Verificar respostas anteriores:

    if (this.$store.getters.answerValue(this.questionId)) {
      var Anwser = this.$store.getters.answerValue(this.questionId);
      this.answerList = [];
      var s = Anwser.split(";");
      if (s.length == 1) {
        this.answerList.push(s[0]);
        this.nselected++;
      }
      for (i = 0; i < s.length - 1; i++) {
        this.answerList.push(s[i]);
        this.nselected++;
      }
      this.multiSelectChanged();
      this.show = true;
    } else this.list = this.options;
    this.processList();
    if (this.showVotePercent) {
      this.assignDemoVotePercents();
      this.loadVotePercents();
    }
  },
  mounted() {
    this.updateMobileView();
    window.addEventListener("resize", this.updateMobileView);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateMobileView);
    document.body.style.overflow = "";
  },
  methods: {
    imgpath(index) {
      const s = `${configDomain}/prj/${this.$store.state.project.projectID}/${this.questionId}_${index + 1}.webp`;
      return s;
    },
    imgpathZoom(index) {
      const s = `${configDomain}/prj/${this.$store.state.project.projectID}/${this.questionId}_${index + 1}_zoom.webp`;
      return s;
    },
    getBtnType: function (value) {
      //alert(value);
      if (this.answerList.length != 0) {
        if (this.answerList.includes(value)) return "filled";
        else {
          return "border";
        }
      } else {
        return "border";
      }
    },
    allKeys() {
      this.list = [];
      //filtrar a lista
      for (var i = 0; i < this.options.length; i++) {
        //if (this.options[i].text.toUpperCase().startsWith(this.qtAnwser.toUpperCase().trim()))
        if (!this.answerList.includes(this.options[i].text))
          if (
              this.options[i].text
                  .toUpperCase()
                  .includes(this.qtAnwser.toUpperCase().trim())
          )
            this.list.push(this.options[i]);
      }
      //this.show = true;
      //this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    mountAnswer: function () {
      var resp = "";
      for (var i = 0; i < this.answerList.length; i++) {
        resp = resp + this.answerList[i] + ";";
      }
      return resp;
    },
    removeOption(opt) {
      var ln = [];
      //somente remontamos a lista
      for (var i = 0; i < this.answerList.length; i++) {
        if (this.answerList[i] != opt) ln.push(this.answerList[i]);
      }

      this.answerList = ln;
      this.multiSelectChanged();

      this.nselected--;
      var resp = this.mountAnswer();
      this.$emit("AnswerChanged", resp, this.questionId);
    },

    multiSelectChanged() {
      this.list = [];

      // remonta a lista - com todas opções
      this.list = [...this.options]

      //remonta a lista - removendo a escolhida
      // for (var i = 0; i < this.options.length; i++) {
      //   if (!this.answerList.includes(this.options[i].text))
      //     this.list.push(this.options[i]);
      // }
    },

    showList() {
      this.show = true;
    },
    CheckEscape(value) {
      var escape = false;
      if (this.config.includes("escape=")) {
        var opts = this.config.split(";");

        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("escape=")) {
            var r = opts[i].split("=");
            if (r[1].includes(value)) escape = true;
          }
        }
      }
      return escape;
    },
    ChooseOption(opt, event) {
      if (this.nMax == 1 || this.CheckEscape(opt)) {
        if (this.showInput) this.show = false;
        this.qtAnwser = opt;
        this.answerList = [];
        this.answerList.push(opt);

        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
        if (this.showVotePercent) {
          this.loadVotePercents();
        }
      } else {
        var resp = "";
        if (this.nselected <= this.nMax) {
          this.nselected++;
          this.answerList.push(opt);
          resp = this.mountAnswer();
          this.multiSelectChanged();
          if (this.nselected == this.nMax) {
            this.$emit("QuestionAnwered", resp, this.questionId);
            if (this.showVotePercent) {
              this.loadVotePercents();
            }
          } else {
            this.$emit("AnswerChanged", resp, this.questionId);
          }
        } else {
          //    this.multiSelectChanged();
          event.stopPropagation();
        }
      }
    },
    processList() {
      this.list.forEach(item => {
        let obj = {}
        obj.text = item.text
        obj.ilustration = item.ilustration
        obj.reloadKey = true // just to reload the video component when ended
        let array = item.ilustration.split('&')
        array.forEach(el => {
          const eqIndex = el.indexOf('=');
          if (eqIndex === -1) return;
          const prop = el.slice(0, eqIndex);
          obj[prop] = el.slice(eqIndex + 1);
        })
        this.newList.push(obj)
      })
    },
    assignDemoVotePercents() {
      const optionsWithoutPercent = this.newList.filter((opt) => {
        return (
          this.votePercents[opt.text] == null &&
          (opt.votePercent == null || opt.votePercent === "")
        );
      });

      if (!optionsWithoutPercent.length) return;

      let remaining = 100;
      optionsWithoutPercent.forEach((opt, index) => {
        if (index === optionsWithoutPercent.length - 1) {
          opt.demoVotePercent = remaining;
          return;
        }

        const slotsLeft = optionsWithoutPercent.length - index - 1;
        const max = Math.max(1, remaining - slotsLeft);
        const value = Math.floor(Math.random() * max) + 1;
        opt.demoVotePercent = value;
        remaining -= value;
      });
    },
    getImageStyle(opt) {
      return {
        width: "100%",
        aspectRatio: opt.aspectRatio,
        objectFit: "cover",
        objectPosition: opt.objectPosition
      };
    },
    getMobileImageStyle(opt) {
      return {
        width: "100%",
        objectFit: "contain",
        objectPosition: opt.objectPosition || "center"
      };
    },
    updateMobileView() {
      this.isMobileView = window.innerWidth <= 767;
      if (!this.isMobileView && this.imagePreview.open) {
        this.closeImagePreview();
      }
    },
    openImagePreview(opt) {
      if (!this.isMobileView || !opt?.url) return;

      this.imagePreview = {
        open: true,
        url: opt.url,
        alt: opt.text || ""
      };
      document.body.style.overflow = "hidden";
    },
    closeImagePreview() {
      this.imagePreview.open = false;
      document.body.style.overflow = "";
    },
    getVotePercent(opt) {
      if (this.votePercents[opt.text] != null) {
        return this.votePercents[opt.text];
      }

      if (opt.votePercent != null && opt.votePercent !== "") {
        return Number(opt.votePercent);
      }

      if (opt.demoVotePercent != null) {
        return opt.demoVotePercent;
      }

      return 0;
    },
    formatVotePercent(value) {
      const percent = Math.round(Number(value));
      if (isNaN(percent)) return "";
      return `${percent}% das pessoas votaram`;
    },
    formatVotePercentShort(value) {
      const percent = Math.round(Number(value));
      if (isNaN(percent)) return "";
      return `${percent}% dos votos`;
    },
    loadVotePercents() {
      const surveyId =
        this.template?.survey?.id ||
        this.$store.state.surveyStruct?.surveyId;

      if (!surveyId) return;

      s.PrevResult(surveyId).then((ret) => {
        const results = ret?.result || [];
        let questionResult = results.find(
          (item) =>
            Number(item.questionId) === Number(this.questionId) ||
            Number(item.id) === Number(this.questionId)
        );

        if (!questionResult && results.length) {
          questionResult = results[0];
        }

        if (!questionResult?.answers) return;

        const map = {};
        questionResult.answers.forEach((item) => {
          if (item.answer != null) {
            map[item.answer] = Number(item.perc);
          }
        });

        this.votePercents = map;
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.gallery-question-header {
  margin-bottom: 60px;
}

.gallery-question-title {
  margin-top: 3rem;
}

.gallery-question-description {
  margin-top: 0.75rem;
  margin-bottom: 0;
}

.c-seledted-btn {
  background-color: black;
  color: white;
}
.c-seledted-btn:hover {
  background-color: black !important;
  opacity: 0.8;
}

.img-btn:hover {
  transform: scale(1.05);
}

.gallery-vote-btn {
  padding: 15px 5px;
}

.gallery-grid--circle,
.gallery-grid--square {
  width: 100%;
}

@media (max-width: 767px) {
  .gallery-question-header {
    margin-bottom: 1rem;
  }

  .gallery-question-title {
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
    padding-top: 0;
    padding-bottom: 0;
  }

  .gallery-grid--square .gallery-item--square {
    padding: 0.35rem !important;
  }

  .gallery-grid--square .gallery-item--square .gallery-item-title {
    font-size: 0.8rem;
    line-height: 1.2;
    padding-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .gallery-grid--square .gallery-item--square .gallery-vote-percent {
    font-size: 0.65rem;
    line-height: 1.2;
    margin-top: 0.35rem !important;
  }

  .gallery-grid--square .gallery-item--square .gallery-vote-btn {
    font-size: 0.7rem;
    padding: 8px 2px !important;
    margin-top: 0.5rem !important;
  }

  .gallery-grid--square .gallery-item--square .img-btn:hover {
    transform: none;
  }

  .gallery-image-wrap--square {
    width: 100%;
    cursor: pointer;
    line-height: 0;
  }

  .gallery-image-wrap--square .gallery-image--mobile {
    width: 100%;
    max-height: 160px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  .gallery-image-wrap--clickable {
    cursor: pointer;
  }

  .gallery-grid--circle .gallery-item--circle {
    padding: 0.35rem !important;
  }

  .gallery-grid--circle .gallery-item--circle .gallery-item-title {
    font-size: 0.8rem;
    line-height: 1.2;
    padding-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .gallery-grid--circle .gallery-item--circle .gallery-image-wrap--circle {
    width: 78%;
    max-width: 145px;
    border-width: 2px;
  }

  .gallery-grid--circle .gallery-item--circle .gallery-vote-percent {
    font-size: 0.65rem;
    line-height: 1.2;
    margin-top: 0.35rem !important;
  }

  .gallery-grid--circle .gallery-item--circle .gallery-vote-btn {
    font-size: 0.7rem;
    padding: 8px 2px !important;
    margin-top: 0.5rem !important;
  }

  .gallery-grid--circle .gallery-item--circle .img-btn:hover {
    transform: none;
  }
}

.gallery-image-wrap--circle {
  display: block;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  width: 70%;
  max-width: 220px;
  margin: 0 auto;
  align-self: center;
  border-radius: 50%;
  border: 3px solid transparent;
  box-sizing: border-box;
  flex-shrink: 0;
}

.gallery-image-wrap--circle .gallery-circle-static {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 0;
}

.gallery-image-wrap--circle .vh--holder {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  cursor: default;
  pointer-events: none;
  touch-action: auto;
}

.gallery-image-wrap--circle .gallery-image--circle {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  pointer-events: none;
}

.gallery-vote-percent {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.3;
}

.gallery-vote-percent__mobile {
  display: none;
}

@media (max-width: 767px) {
  .gallery-vote-percent__desktop {
    display: none;
  }

  .gallery-vote-percent__mobile {
    display: inline;
  }
}

.gallery-image-preview {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.92);
}

.gallery-image-preview__img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.gallery-image-preview__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
}

.vs-card--content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


/* .question .form-group > label {
  font-size: 1.25rem;
  letter-spacing: -0.48px;
  font-weight: bold;
}
.question .form-group input {
  border: none;
  border-left: 2px solid #038835 !important;
  font-size: 1.5rem;
  margin: 1rem 0 0;
}
.question .form-group input:focus {
  border: none !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255) !important;
  border-left: 2px solid #038835 !important;
}
.question form .btn-primary {
  width: 50% !important;
  display: inline-block !important;
}
.question form .instrucao {
  display: inline-block;
}

.iconx {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #dfe2e6;
  color: #dfe2e6;
}

.btnOtion {
  width: 100%;
}

.q-title {
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #40424a;
}

.q-list-answer {
  width: 351px;
  height: 40px;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #40424a;
  display: inline-block;
  vertical-align: middle;
}

.q-text-answer .text-style-1 {
  color: #038835;
} */
</style>
